// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"ec02b68d","458":"1a1980ff","774":"5adc8379","787":"37b542a8","807":"1c0a6274","820":"7baf1562","858":"9aaec2b2","910":"01d47306"}[chunkId] + ".chunk.js";
};